export const STORAGE_KEY = "wardaSharepages";
